<div class="container">
    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-1 .1-1.3.5l-.7.9c-.4.4-.2 1.1.3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.4 5.9c.2.5.9.7 1.3.3l.9-.7c.4-.3.6-.8.5-1.3z"/>
            </svg>
        </div>

        <div style="flex: 1;">
            <h1>Cadastro de Aeronave</h1>
            <p>Gerenciamento de frotas e operadores</p>
        </div>

        <!-- Botões de Ação no Topo -->
        <div style="display: flex; gap: 10px; align-items: center;">
            <button type="button" class="btn-salvar-header"
                    [disabled]="salvando()" (click)="salvarAeronave()">
                <svg *ngIf="!salvando()" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                    <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                </svg>
                <app-loading-indicator *ngIf="salvando()" size="inline"></app-loading-indicator>
                Salvar
            </button>

            <button type="button"
                    style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
                    (click)="limparFormulario()">
                Limpar
            </button>

            <button type="button"
                    style="background:rgba(255,255,255,0.15);border:1px solid rgba(255,255,255,0.3);color:#fff;border-radius:8px;padding:8px 16px;cursor:pointer;display:flex;align-items:center;gap:6px;font-size:13px;font-weight: 500;"
                    (click)="voltar.emit()">
                Voltar
            </button>
        </div>
    </div>

    <form [formGroup]="aeronaveForm" (ngSubmit)="salvarAeronave()">

        <!-- CARD PRINCIPAL: Identificação e Propriedade -->
        <div class="card">
            <div class="card-title">Identificação & Propriedade</div>
            <div class="form-grid">

                <div class="field col-2" style="position: relative;" [class.busca-autocomplete-aberta]="dropdownPrefixoAberto()">
                    <label>Prefixo <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="prefixo" maxlength="10" placeholder="EX: PT-ABC"
                           (input)="onInputPrefixo($event)"
                           (keydown)="onKeyDownNavegacaoPrefixo($event)"
                           (blur)="fecharDropdownPrefixo()"
                           style="text-transform: uppercase;"
                           [class.campo-invalido]="aeronaveForm.get('prefixo')?.touched && aeronaveForm.get('prefixo')?.invalid">

                    <!-- DROPDOWN DE SUGESTÕES DO SANKHYA -->
                    <div class="autocomplete-dropdown" *ngIf="dropdownPrefixoAberto()">
                        <div class="autocomplete-item"
                             *ngFor="let a of sugestoesPrefixo(); let idx = index"
                             [class.autocomplete-item-ativo]="indiceFocoAtual() === idx"
                             (mousedown)="selecionarAeronaveSankhya(a)">
                            <strong>{{ a.PREFIXO }}</strong> <span *ngIf="a.PROPRIETARIO"> - {{ a.PROPRIETARIO }}</span>
                        </div>

                        <!-- OPÇÃO DE CADASTRAR NOVO (ANAC) -->
                        <div class="autocomplete-item"
                             style="color: var(--primary); font-weight: 600; justify-content: center; background: #f0fdf4;"
                             *ngIf="sugestoesPrefixo().length === 0 && !buscandoPrefixo()"
                             (mousedown)="cadastrarNovoPrefixo()">
                            + Cadastrar novo prefixo e buscar na ANAC
                        </div>
                    </div>

                    <!-- MENSAGEM DE BUSCA -->
                    <div *ngIf="buscandoPrefixo()" style="color: var(--primary); font-size: 10px; font-weight: 600; margin-top: 4px;">
                        <app-loading-indicator size="inline"></app-loading-indicator>
                        Consultando aeronave...
                    </div>
                </div>

                <div class="field col-3">
                    <label>Proprietário<span class="campo-obrigatorio-asterisco">*</span></label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirModalParceiro('PROPRIETARIO')" title="Buscar Parceiro">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input" formControlName="proprietario" 
                                placeholder="Clique para abrir a consulta" readonly (click)="abrirModalParceiro('PROPRIETARIO')">
                    </div>
                </div>

                <div class="field col-3">
                    <label>CPF / CNPJ Proprietário <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="cpfCnpj" (input)="aplicarMascaraCpfCnpj($event, 'cpfCnpj')" maxlength="18">
                </div>

                <div class="field col-2">
                    <label>Cota Parte (%)</label>
                    <input type="number" formControlName="cotaParte" min="0" max="100">
                </div>

                <div class="field col-2">
                    <label>Data Compra/Transf.</label>
                    <input type="date" formControlName="dtCompraTransf">
                </div>

                <div class="field col-4">
                    <label>Operador<span class="campo-obrigatorio-asterisco">*</span></label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirModalParceiro('OPERADOR')" title="Buscar Parceiro">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input" formControlName="operador" 
                                placeholder="Clique para abrir a consulta" readonly (click)="abrirModalParceiro('OPERADOR')">
                    </div>
                </div>

                <div class="field col-4">
                    <label>CPF / CNPJ Operador<span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="cpfCnpjOperador" (input)="aplicarMascaraCpfCnpj($event, 'cpfCnpjOperador')" maxlength="18">
                </div>

            </div>
        </div>

        <!-- CARD TÉCNICO: Dados de Fabricação e Modelo -->
        <div class="card">
            <div class="card-title">Dados Técnicos e Homologação</div>
            <div class="form-grid">

                <div class="field col-3">
                    <label>Fabricante <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="fabricante">
                </div>

                <div class="field col-2">
                    <label>Ano de Fabricação</label>
                    <input type="number" formControlName="anoFabricacao" min="1900" max="2050">
                </div>

                <div class="field col-3">
                    <label>Modelo <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="modelo">
                </div>

                <div class="field col-4">
                    <label>Número de Série <span class="campo-obrigatorio-asterisco">*</span></label>
                    <input type="text" formControlName="numeroSerie">
                </div>

                <div class="field col-2">
                    <label>Tipo ICAO</label>
                    <input type="text" formControlName="tipoIcao" maxlength="4" placeholder="EX: A20N">
                </div>

                <div class="field col-4">
                    <label>Categoria de Homologação (ANAC)</label>
                    <select formControlName="categoriaHomologacao">
                        <option value="">Selecione...</option>
                        <option value="ACROB./RESTRITA">ACROB./RESTRITA</option>
                        <option value="ACROBATICA">ACROBATICA</option>
                        <option value="CLASSE ESPECIAL">CLASSE ESPECIAL</option>
                        <option value="NAO CERTIFICADA">NÃO CERTIFICADA</option>
                        <option value="NORMAL">NORMAL</option>
                        <option value="NORMAL/ACROBATICA">NORMAL/ACROBATICA</option>
                        <option value="NORMAL/RESTRITA">NORMAL/RESTRITA</option>
                        <option value="NORMAL/S.ACROB.">NORMAL/S.ACROB.</option>
                        <option value="NORMAL/UTILIDADE">NORMAL/UTILIDADE</option>
                        <option value="RESTRITA">RESTRITA</option>
                        <option value="RPAS AUTORIZADO">RPAS AUTORIZADO</option>
                        <option value="TRANSP.REGIONAL">TRANSP.REGIONAL</option>
                        <option value="TRANSPORTE">TRANSPORTE</option>
                        <option value="TRANSPORTE A">TRANSPORTE A</option>
                        <option value="TRANSPORTE A/B">TRANSPORTE A/B</option>
                        <option value="TRANSPORTE B">TRANSPORTE B</option>
                        <option value="UTIL./ACROBATICA">UTIL./ACROBATICA</option>
                        <option value="UTILIDADE">UTILIDADE</option>
                    </select>
                </div>

                <div class="field col-3">
                    <label>Tipo Habilitação Pilotos</label>
                    <input type="text" formControlName="tipoHabilitacaoPilotos" placeholder="EX: MNTE, MLTE">
                </div>

                <div class="field col-3">
                    <label>Classe da Aeronave (ANAC)</label>
                    <select formControlName="classeAeronave">
                        <option value="">Selecione...</option>
                        <option value="ANFIBIO 1 MOTOR CONVENCIONAL">ANFIBIO 1 MOTOR CONVENCIONAL</option>
                        <option value="ANFIBIO 1 MOTOR TURBOHELICE">ANFIBIO 1 MOTOR TURBOHELICE</option>
                        <option value="DRONE (RPAS) 1 DRONE">DRONE (RPAS) 1 DRONE</option>
                        <option value="GIROCOPTERO 1 MOTOR A PISTAO">GIROCOPTERO 1 MOTOR A PISTÃO</option>
                        <option value="HELICOPTERO 1 MOTOR CONVENCIONAL">HELICOPTERO 1 MOTOR CONVENCIONAL</option>
                        <option value="HELICOPTERO 1 MOTOR TURBOEIXO">HELICOPTERO 1 MOTOR TURBOEIXO</option>
                        <option value="HELICOPTERO 2 MOTOR TURBOEIXO">HELICOPTERO 2 MOTOR TURBOEIXO</option>
                        <option value="POUSO CONVECIONAL 0 SEM MOTOR">POUSO CONVECIONAL 0 SEM MOTOR</option>
                        <option value="POUSO CONVECIONAL 1 MOTOR CONVENCIONAL">POUSO CONVECIONAL 1 MOTOR CONVENCIONAL</option>
                        <option value="POUSO CONVECIONAL 1 MOTOR TURBOHELICE">POUSO CONVECIONAL 1 MOTOR TURBOHELICE</option>
                        <option value="POUSO CONVECIONAL 2 MOTORES CONVENCIONAIS">POUSO CONVECIONAL 2 MOTORES CONVENCIONAIS</option>
                        <option value="POUSO CONVECIONAL 2 MOTORES JATO/TURBOFAN">POUSO CONVECIONAL 2 MOTORES JATO/TURBOFAN</option>
                        <option value="POUSO CONVECIONAL 2 MOTORES TURBOHELICE">POUSO CONVECIONAL 2 MOTORES TURBOHELICE</option>
                        <option value="POUSO CONVECIONAL 3 MOTORES JATO/TURBOFAN">POUSO CONVECIONAL 3 MOTORES JATO/TURBOFAN</option>
                        <option value="POUSO NA AGUA 1 MOTOR CONVENCIONAL">POUSO NA AGUA 1 MOTOR CONVENCIONAL</option>
                        <option value="Outro">DIGITAR OUTRO...</option>
                    </select>
                    
                    <!-- Fallback dinâmico caso selecione "Outro" ou queira digitar livremente -->
                    <input type="text" style="margin-top: 4px;" *ngIf="aeronaveForm.get('classeAeronave')?.value === 'Outro'" formControlName="classeAeronaveTexto" placeholder="Digite a classe...">
                </div>

            </div>
        </div>

        <!-- CARD OPERACIONAL: Capacidades e Registro -->
        <div class="card">
            <div class="card-title">Capacidades e Situação Legal</div>
            <div class="form-grid">

                <div class="field col-2">
                    <label>PMD (Peso Máx. Decolagem - Kg)</label>
                    <input type="number" formControlName="pesoMaximoDecolagem">
                </div>

                <div class="field col-2">
                    <label>Nº de Passageiros</label>
                    <input type="number" formControlName="numeroPassageiros">
                </div>

                <div class="field col-4">
                    <label>Tipo de Voo Autorizado</label>
                    <select formControlName="tipoVooAutorizado">
                        <option value="">Selecione...</option>
                        <option value="VFR_DIURNO">VFR DIURNO</option>
                        <option value="VFR_NOTURNO">VFR NOTURNO</option>
                        <option value="IFR_DIURNO">IFR DIURNO</option>
                        <option value="IFR_NOTURNO">IFR NOTURNO</option>
                        <option value="Outro">DIGITAR OUTRO...</option>
                    </select>
                    <input type="text" style="margin-top: 4px;" *ngIf="aeronaveForm.get('tipoVooAutorizado')?.value === 'Outro'" formControlName="tipoVooAutorizadoTexto" placeholder="Digite a autorização...">
                </div>

                <div class="field col-2">
                    <label>Tripulação Mínima</label>
                    <input type="number" formControlName="tripulacaoMinima">
                </div>

                <div class="field col-2">
                    <label>Número de Assentos</label>
                    <input type="number" formControlName="numeroAssentos">
                </div>

                <div class="field col-3">
                    <label>Categoria de Registro</label>
                    <input type="text" formControlName="categoriaRegistro">
                </div>

                <div class="field col-3">
                    <label>Número da Matrícula</label>
                    <input type="text" formControlName="numeroMatricula">
                </div>

                <div class="field col-3">
                    <label>Status Operação</label>
                    <input type="text" formControlName="statusOperacao" class="form-control" placeholder="Digite o status da operação" />
                </div>

                <div class="field col-3">
                    <label>Gravame (ANAC)</label>
                    <select formControlName="gravame">
                        <option value="">Nenhum (Vazio)</option>
                        <option value="NENHUM GRAVAME REGISTRADO">NENHUM GRAVAME REGISTRADO</option>
                        <option value="ALIENACAO FIDUCIARIA">ALIENAÇÃO FIDUCIÁRIA</option>
                        <option value="ARRENDAMENTO MERCANTIL">ARRENDAMENTO MERCANTIL</option>
                        <option value="ARRENDAMENTO OPERACIONAL">ARRENDAMENTO OPERACIONAL</option>
                        <option value="ARROLAMENTO DE BENS E DIREITOS DA RECEITA FEDERAL">ARROLAMENTO DE BENS E DIREITOS DA RECEITA FEDERAL</option>
                        <option value="AVERBACAO DE ACAO EM TRAMITE">AVERBAÇÃO DE AÇÃO EM TRAMITE</option>
                        <option value="BASE LEGADA">BASE LEGADA</option>
                        <option value="CESSAO DE USO NAO ONEROSA">CESSÃO DE USO NÃO ONEROSA</option>
                        <option value="CLAUSULA DE INALIENABILIDADE">CLÁUSULA DE INALIENABILIDADE</option>
                        <option value="CLAUSULA DE INCOMUNICABILIDADE">CLÁUSULA DE INCOMUNICABILIDADE</option>
                        <option value="CLAUSULA DE RESERVA DE DOMINÍO">CLÁUSULA DE RESERVA DE DOMINÍO</option>
                        <option value="COMUNICACAO DE OCORRÊNCIA POLICIAL">COMUNICAÇÃO DE OCORRÊNCIA POLICIAL</option>
                        <option value="COMUNICACAO DE VENDA">COMUNICAÇÃO DE VENDA</option>
                        <option value="HIPOTECA">HIPOTECA</option>
                        <option value="INTERCAMBIO OPERACIONAL">INTERCÂMBIO OPERACIONAL</option>
                        <option value="MATRICULA CANCELADA">MATRICULA CANCELADA</option>
                        <option value="MATRICULA EXPEDITA - Matricula sob analise - eventuais gravames podem incidir">MATRICULA EXPEDITA - Matrícula sob análise - eventuais gravames podem incidir</option>
                        <option value="O.J. DE OPERACAO POR TERCEIRO">O.J. DE OPERAÇÃO POR TERCEIRO</option>
                        <option value="O.J. RESTRITIVA DE TRANSFERÊNCIA">O.J. RESTRITIVA DE TRANSFERÊNCIA</option>
                        <option value="O.J. RESTRITIVA DE VOO">O.J. RESTRITIVA DE VOO</option>
                        <option value="OPERADOR INVENTARIANTE">OPERADOR INVENTARIANTE</option>
                        <option value="ORDEM JUDICIAL">ORDEM JUDICIAL</option>
                        <option value="PENHOR">PENHOR</option>
                        <option value="PROGRAMA DE COMPARTILHAMENTO">PROGRAMA DE COMPARTILHAMENTO</option>
                        <option value="PROMESSA DE COMPRA E VENDA">PROMESSA DE COMPRA E VENDA</option>
                        <option value="PROPRIETARIO FALECIDO">PROPRIETÁRIO FALECIDO</option>
                        <option value="RESERVADAS AS MARCAS">RESERVADAS AS MARCAS</option>
                        <option value="RESTRICAO ADMINISTRATIVA">RESTRIÇÃO ADMINISTRATIVA</option>
                    </select>
                    <input type="text" style="margin-top: 4px;" *ngIf="aeronaveForm.get('gravame')?.value === 'Outro'" formControlName="gravameTexto" placeholder="Digite o gravame...">
                </div>

                <div class="field col-3">
                    <label>Data Vencimento CVA</label>
                    <input type="date" formControlName="dtValCva">
                </div>

                <div class="field col-4">
                    <label>Situação de Aeronavegabilidade</label>
                    <select formControlName="sitAeronavegabilidade">
                        <option value="">Selecione...</option>
                        <option value="SITUACAO NORMAL">SITUAÇÃO NORMAL</option>
                        <option value="AERONAVE EXPERIMENTAL (SITUACAO NORMAL)">AERONAVE EXPERIMENTAL (SITUAÇÃO NORMAL)</option>
                        <option value="CERTIFICADO DE AERONAVEGABILIDADE (C.A) SUSPENSO">CERTIFICADO DE AERONAVEGABILIDADE (C.A) SUSPENSO</option>
                        <option value="CERTIFICADO DE AERONAVEGABILIDADE (C.A) CANCELADO">CERTIFICADO DE AERONAVEGABILIDADE (C.A) CANCELADO</option>
                        <option value="MATRICULA CANCELADA">MATRÍCULA CANCELADA</option>
                        <option value="AERONAVE INTERDITADA">AERONAVE INTERDITADA</option>
                    </select>
                    <input type="text" style="margin-top: 4px;" *ngIf="aeronaveForm.get('sitAeronavegabilidade')?.value === 'Outro'" formControlName="sitAeronavegabilidadeTexto" placeholder="Digite a situação...">
                </div>

                <div class="field col-5">
                    <label>Motivos</label>
                    <input type="text" formControlName="motivos" placeholder="Observações de restrição ou status...">
                </div>

            </div>
        </div>

        <!-- CARD DE VÍNCULO DE PARCEIROS (AGRUPADO POR PESSOA / DOCUMENTO) -->
        <div class="card">
            <div class="card-title" style="justify-content: space-between;">
                Parceiros Co-Proprietários / Vinculados
                <button type="button" class="btn secondary btn-sm" (click)="adicionarParceiroVinculado()">+ Adicionar</button>
            </div>

            <div formArrayName="parceirosVinculados">
                <!-- Grid dividido em 2 colunas -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">

                    <!-- Loop de Parceiros Vinculados -->
                    <div *ngFor="let parcCtrl of parceirosVinculadosFormArray.controls; let i = index" [formGroupName]="i" class="sub-card" style="margin-bottom: 0;">
                        <div class="sub-card-header">
                            <strong>Parceiro {{ i + 1 }}</strong>
                            <button type="button" class="busca-combo-clear" (click)="removerParceiroVinculado(i)" title="Remover">✕</button>
                        </div>
                        <div class="sub-card-body form-grid">

                            <!-- Campo de Busca de Parceiro por Nome ou Documento -->
                            <div class="field col-6" [class.busca-autocomplete-aberta]="dropdownVinculoAberto() === i">
                                <label>Pessoa / CPF/CNPJ <span class="campo-obrigatorio-asterisco">*</span></label>
                                <div class="busca-combo" [class.campo-invalido]="parcCtrl.get('cpfCnpj')?.touched && parcCtrl.get('cpfCnpj')?.invalid">
                                    <input type="text" class="busca-combo-input"
                                           [value]="valorExibidoParceiroVinculado(parcCtrl.value)"
                                           (input)="onInputParceiroVinculado($event, i)"
                                           (keydown)="onKeyDownNavegacaoVinculo($event, i)"
                                           (blur)="fecharDropdownVinculo()"
                                           placeholder="Digite CPF/CNPJ ou nome...">
                                </div>

                                <!-- DROPDOWN DE AUTOCOMPLETE -->
                                <div class="autocomplete-dropdown" *ngIf="dropdownVinculoAberto() === i">
                                    <div class="autocomplete-item"
                                         *ngFor="let p of parceirosFiltradosInline(i); let idx = index"
                                         [class.autocomplete-item-ativo]="indiceFocoAtual() === idx"
                                         (mousedown)="selecionarParceiroInline(p, i)">
                                        <div style="font-weight: 600; color: var(--text-main);">{{ p.nomeParc || p.nomeparc }}</div>
                                        <div style="font-size: 11px; color: var(--text-muted);">
                                            Doc: {{ formatarCpfCnpjExibicao(p.docparc || p.cpfCnpj || p.CGC_CPF) }}
                                        </div>
                                    </div>
                                    <div class="autocomplete-empty" *ngIf="parceirosFiltradosInline(i).length === 0">Nenhum encontrado.</div>
                                </div>
                            </div>

                            <!-- Seleção do Tipo de Vínculo -->
                            <div class="field col-6">
                                <label>Tipo de Vínculo <span class="campo-obrigatorio-asterisco">*</span></label>
                                <select formControlName="tipoVinculo" [class.campo-invalido]="parcCtrl.get('tipoVinculo')?.touched && parcCtrl.get('tipoVinculo')?.invalid">
                                    <option value="">Selecione...</option>
                                    <option value="PROPRIET">Proprietário</option>
                                    <option value="OFICINA">Oficina</option>
                                    <option value="PILOTO">Piloto</option>
                                    <option value="RESPONS">Responsável</option>
                                </select>
                            </div>

                            <!-- Tag com feedback das filiais/CODPARCs agrupadas -->
                            <div class="col-12" *ngIf="parcCtrl.get('codParcs')?.value?.length > 0"
                                 style="font-size: 11px; color: #16a34a; font-weight: 500; margin-top: 4px; background: #f0fdf4; padding: 6px 10px; border-radius: 4px; border: 1px solid #bbf7d0;">
                                ✓ {{ parcCtrl.get('codParcs')?.value?.length }} cadastro(s) no Sankhya serão vinculados a esta aeronave (CODPARCs: <strong>{{ parcCtrl.get('codParcs')?.value.join(', ') }}</strong>)
                            </div>

                        </div>
                    </div>

                </div>

                <!-- Mensagem padrão quando vazia -->
                <div *ngIf="parceirosVinculadosFormArray.length === 0" style="font-size: 11px; color: var(--text-muted); padding-top: 8px;">Nenhum parceiro adicional vinculado.</div>
            </div>
        </div>

        <!-- AÇÕES -->
        <div class="btn-actions" style="margin-bottom: 40px; justify-content: flex-end; display: flex; gap: 10px;">
            <button type="submit" class="btn primary" [disabled]="salvando()"><app-loading-indicator *ngIf="salvando()" size="inline"></app-loading-indicator>
                {{ salvando() ? 'Salvando...' : 'Salvar Aeronave' }}
            </button>
        </div>
    </form>
</div>

<!-- ======================================================================= -->
<!-- MODAL DE BUSCA COM DESFOQUE DE FUNDO (Adaptado do Relatório)[cite: 4]  -->
<!-- ======================================================================= -->
<div class="modal-overlay" *ngIf="modalParceiroAberta">
    <div class="modal-box">
        <div class="modal-header">
            Buscar {{ tipoBuscaAtiva === 'PROPRIETARIO' ? 'Proprietário' : 'Operador' }}
        </div>
        <div class="modal-body">
            <input type="text" class="busca-modal-input"
                   [(ngModel)]="filtroBuscaModal"
                   [ngModelOptions]="{standalone: true}"
                   (input)="agendarBuscaParceirosModal()"
                   placeholder="Digite o nome, código ou documento..." autofocus>

            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let p of listaParceirosSugeridos()" (click)="selecionarParceiroModal(p)">
                    <div style="font-weight: 700; color: var(--text-main); margin-bottom: 2px;">{{ p.nomeparc }}</div>
                    <div style="font-size: 10px; color: var(--text-muted);">
                        Código: <strong>{{ p.codparc }}</strong> | Doc: {{ p.docparc || 'Não informado' }}
                    </div>
                </div>
                <div class="busca-modal-empty" *ngIf="!listaParceirosSugeridos().length" style="padding: 16px; text-align: center; color: var(--text-muted); font-size: 11px;">
                    {{ statusBuscaParceiro }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn secondary" (click)="fecharModalParceiro()">Cancelar</button>
        </div>
    </div>
</div>

<!-- SISTEMA NOTIFICAÇÃO TOAST -->
<div class="toast-container" *ngIf="toast()">
    <div class="toast-box" [ngClass]="toast()?.tipo">
        <span class="toast-mensagem">{{ toast()?.mensagem }}</span>
        <button type="button" class="toast-fechar" (click)="toast.set(null)">✕</button>
    </div>
</div>